import { render } from "./UEWasteWaterEditView.vue?vue&type=template&id=af79e500&scoped=true"
import script from "./UEWasteWaterEditView.vue?vue&type=script&lang=js"
export * from "./UEWasteWaterEditView.vue?vue&type=script&lang=js"

import "./UEWasteWaterEditView.vue?vue&type=style&index=0&id=af79e500&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af79e500"]])

export default __exports__